import { createSelector } from 'reselect';
import { RESPONSIVE_RANGES } from 'utils/enums';
/**
 * @return {integrationModel}
 */
export const integrationSelector = createSelector(
  (state) => state.integration,
  (integration) => integration
);

export const isDeviceSelector = createSelector(integrationSelector, (integration) => integration.isDevice);

export const viewRangeSelector = createSelector(integrationSelector, (integration) => integration.viewRange);

export const sizeSelector = createSelector(integrationSelector, (integration) => integration.size);

export const isMobileSelector = createSelector(
  integrationSelector,
  ({ viewRange }) => viewRange === RESPONSIVE_RANGES.MOBILE_SMALL || viewRange === RESPONSIVE_RANGES.MOBILE_LARGE
);
